document.addEventListener('alpine:init', () => {
  Alpine.data('multiform', () => ({
    init() {
      this.$nextTick(() => {
        if (!document.body.classList.contains('wp-admin')) {
          this.$nextTick(() => {});
        }
      });
    },

    change(id) {
      const index = +id.slice(2);

      this.$refs.forms.classList.remove('hidden');

      for (const [i, block] of [...this.$refs.forms.children].entries()) {
        if (index === i) {
          block.classList.remove('hidden');
        } else {
          block.classList.add('hidden');
        }
      }
    },
  }));
});